export interface FileValidationResult {
  file: File;
  valid: boolean;
  errors: string[];
}

const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
const PDF_BYTES = [0x25, 0x50, 0x44, 0x46];

export function formatSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
}

async function validatePdfSignature(file: File): Promise<boolean> {
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.onload = e => {
      const arr = new Uint8Array(e.target?.result as ArrayBuffer);
      const isValid = PDF_BYTES.every((byte, i) => arr[i] === byte);
      resolve(isValid);
    };
    reader.onerror = () => resolve(false);
    reader.readAsArrayBuffer(file.slice(0, 4));
  });
}

export async function validateFile(file: File): Promise<FileValidationResult> {
  const errors: string[] = [];

  if (!file.name.toLowerCase().endsWith('.pdf')) {
    errors.push('Not a .pdf file');
    return { file, valid: false, errors };
  }

  if (file.size > MAX_FILE_SIZE) {
    errors.push(`File size too big (max size 10mb).`);
  }

  const sigValid = await validatePdfSignature(file);
  if (!sigValid) {
    errors.push('Invalid PDF signature — file may be corrupted');
  }

  return { file, valid: errors.length === 0, errors };
}
